import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';
import './Care.scss';
import { CareInputSelector, setTriggerRefreshInput, setTriggerSave } from './reducers/CareInputReducer';
import { resetCareSearch, setTriggerCareSearch } from './reducers/CareSearchReducer';
// import CareInput from './CareInput';
import CareSearch from './CareSearch';
import CareTable from './CareTable';
import CareInput from './CareInput';

let triggerHotkeyAlready = false;

const Care: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);
    const CareInputViewData = useSelector(CareInputSelector);

    useEffect(() => {
        document.title = "Care";

        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);
    }, []);

    const handleKeyPress = useCallback((event) => {
        if (!triggerHotkeyAlready) {
            if (event.altKey) {
                switch (event.key) {
                    case "s":
                        //save
                        triggerHotkeyAlready = true;
                        dispatch(setTriggerSave((new Date()).getTime()));
                        break;
                    case "r":
                        //refresh save
                        dispatch(setTriggerRefreshInput((new Date()).getTime()));
                        break;
                    case "w":
                        //search
                        triggerHotkeyAlready = true;
                        dispatch(setTriggerCareSearch((new Date()).getTime()));
                        break;
                    case "q":
                        //refresh search
                        dispatch(resetCareSearch());
                        break;
                    default:
                        break;
                }
            }

            setTimeout(() => {
                triggerHotkeyAlready = false;
            }, 2000);
        }
    }, []);

    return (
        <>
            <Grid container className="tonnage">
                <Grid item lg={2} xs={12} className="left-search-area">
                    <CareSearch></CareSearch>
                </Grid>
                <Grid item lg={10} xs={12} className="right-content">
                    <Grid container className="input-fields">
                        <div className={quickInputData.showQuickInput ? "tonnage-quick-input-collapse" : "tonnage-quick-input-expand"}>
                            <CareInput></CareInput>
                        </div>
                    </Grid>
                    <Grid container className="datatable">
                        <CareTable>
                        </CareTable>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
};

export default Care;